import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, PickaxeIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productImage, productTagline, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} professional volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-background" data-id="element-82" data-mp="s9q8brns6vfz">
      <div className="h-1 w-full bg-primary shadow-[0_0_16px_rgba(0,200,248,0.8)]" aria-hidden="true" data-id="element-83" data-mp="nb6kflpmn9kz" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-84" data-mp="3d2l8d8tzsyz4">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-primary/50 bg-surface px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-foreground shadow-glow" data-id="element-85" data-mp="3825wklpczzj9">
          <PickaxeIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-86" data-mp="3e8wl4tc6p6nh" /> {productBrand}
        </motion.p>

        

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-87" data-mp="30gzvqx1whaus">
          <img src={productImage} alt="Lithium & Critical Minerals Professional Edition: six technical volumes and five bonus resources covering fundamentals, geology, mining and extraction, processing and refining, battery materials, and project economics" className="mx-auto w-full drop-shadow-[0_24px_40px_rgba(0,200,248,0.3)]" data-id="element-88" data-mp="2viokqizvcuaz" />
        </motion.div>

        <div className="mt-9" data-id="element-89" data-mp="s3ck463mvbog">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-90" data-mp="nbbev44vul7x">
            Get your professional edition now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-foreground" data-id="element-91" data-mp="icrngo7ish86">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-primary/40 bg-surface px-3 py-2" data-id="element-92" data-mp="1b15lh3ylzdjq">
              <Icon className="h-3.5 w-3.5 text-primary" aria-hidden="true" data-id="element-93" data-mp="162m0p6vr47sy" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}